import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'

const StyledPageTabs = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 36px;
  .tabs {
    flex: auto;
    display: flex;
    gap: 24px;
    padding: 0;
    margin: 0;
    list-style: none;
    > li {
      padding: 6px 12px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 500;
      border-radius: 100px;
      color: ${props => props.theme.dark4};
      cursor: pointer;
      + li {
        margin-left: 24px;
      }
      &:hover {
        color: ${props => props.theme.dark2};
      }
      &.active {
        background: ${props => props.theme.dark3};
        color: ${props => props.theme.light2};
      }
    }
  }
  .tabs-v2 {
    gap: 0;
    align-items: flex-end;
    height: 40px;
    > li {
      padding: 0;
      font-size: 32px;
      line-height: 1;
      color: var(--neutral-500);
      transition: all 0.3s ease 0s;
      + li {
        margin-left: 24px;
      }
      &:hover {
        color: var(--neutral-500);
      }
      &.active {
        background: unset;
        color: var(--neutral-200);
        font-size: 40px;
      }
    }
  }
`

export interface TabsItemProps {
  key: TabsKey
  name: string
}
export type TabsKey = string | null | undefined | number

export const PageTabs: React.FC<{
  data: TabsItemProps[]
  onChange: (item: TabsItemProps, key: TabsKey) => void
  className?: string
  extra?: React.ReactNode
  value?: TabsKey
  isv2?: boolean
  style?: React.CSSProperties
}> = ({ data, onChange, className, extra, value, isv2, style }) => {
  const [current, setCurrent] = useState<TabsKey>(value)
  const onTabItem = useCallback(
    (item: TabsItemProps) => {
      if (current === item.key) return
      setCurrent(item.key)
      onChange(item, item.key)
    },
    [onChange, current]
  )
  return (
    <StyledPageTabs className={className} style={style}>
      <ul
        className={classNames('tabs', {
          'tabs-v2': isv2,
        })}
      >
        {data.map(item => (
          <li
            key={item.key}
            onClick={() => onTabItem(item)}
            className={current === item.key ? 'active' : ''}
          >
            {item.name}
          </li>
        ))}
      </ul>
      {extra}
    </StyledPageTabs>
  )
}
